// extracted by mini-css-extract-plugin
export default {"root":"lY7iJwaLhWy7ju_MAKpq","label":"DDjPiNbQ8ke80RbtzFXm","input":"NECWcnzvXC6uwhEbAQkM","datePicker":"q9LZggW5GSopM2eEDOV2","placeHolderShimmer":"R7uon38QtY2wqhinEQy2"};